import getArrayTaskFromCache from './getArrayTaskFromCache';

export default getArrayTaskFromCache;
